import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchClientSpocListResponse>}
 */
export function requestClientSpocList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/client-spoc`, {
      params: { limit: Number.MAX_SAFE_INTEGER }, 
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/client-spoc?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function getClientSpocList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/client/getClientSpocLeadGen?`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/client/getClientSpocLeadGen?${params}`,
      {
        // params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}
export function requestCreateSpoc(data) {
  return fetch.post(`${BASE_URL}/api/app/client-spoc`, data);
}
export function requestUpdateSpoc(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/client-spoc/${data._id}`, body);
}
